<template>
    <!-- قائمة الجهات بعدد سجلاتها — الصفحة الأولى لإدارة الصيدلة في الطلبات والسندات.
         الضغط على جهة يفتح سجلاتها وحدها (طلب مهندس الوزارة 2026-10-05). -->
    <div class="branch-group-list">
        <div class="px-3 py-2 border-bottom d-flex flex-wrap align-items-center gap-2">
            <input type="search" class="form-control form-control-sm" style="max-width:280px"
                   v-model="nameFilter" placeholder="ابحث باسم المستشفى أو المرفق" />
            <small class="text-muted ms-auto">{{ filteredRows.length }} {{ unitLabel }}</small>
        </div>

        <div v-if="loading" class="text-center text-muted py-4">
            <i class="ti ti-loader-2 ti-spin me-1"></i> جاري التحميل…
        </div>
        <div v-else-if="!filteredRows.length" class="text-center text-muted py-4">
            {{ emptyText }}
        </div>

        <div v-else class="list-group list-group-flush">
            <a v-for="row in filteredRows" :key="row.key"
               href="javascript:;"
               class="list-group-item list-group-item-action d-flex align-items-center gap-3 py-3"
               @click.prevent="$emit('select', row)">
                <div class="avatar avatar-sm flex-shrink-0">
                    <span class="avatar-initial rounded bg-label-primary"><i class="ti ti-building-hospital"></i></span>
                </div>
                <div class="flex-grow-1 min-w-0">
                    <div class="fw-semibold text-heading text-truncate">{{ row.name }}</div>
                    <div class="d-flex flex-wrap gap-1 mt-1">
                        <span v-for="b in row.badges" :key="b.label" class="badge" :class="b.cls">
                            {{ b.label }}: {{ b.value }}
                        </span>
                    </div>
                </div>
                <div class="text-end flex-shrink-0">
                    <div class="fw-bold fs-5">{{ row.total }}</div>
                    <small class="text-muted d-block" v-if="row.lastDate">آخر: {{ formatDate(row.lastDate) }}</small>
                </div>
                <i class="ti ti-chevron-left text-muted"></i>
            </a>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: 'BranchGroupList',
    props: {
        /** [{ key, name, total, lastDate, badges: [{ label, value, cls }] }] — الشارات بقيمة صفر لا تُعرض. */
        rows: { type: Array, default: () => [] },
        loading: { type: Boolean, default: false },
        unitLabel: { type: String, default: 'جهة' },
        emptyText: { type: String, default: 'لا توجد بيانات مطابقة.' },
    },
    data() {
        return { nameFilter: '' };
    },
    computed: {
        filteredRows() {
            const q = (this.nameFilter || '').trim();
            return (this.rows || [])
                .filter((r) => !q || String(r.name || '').includes(q))
                .map((r) => ({ ...r, badges: (r.badges || []).filter((b) => Number(b.value) > 0) }));
        },
    },
    methods: {
        formatDate(d) {
            return d ? moment(d).format('DD/MM/YYYY') : '';
        },
    },
};
</script>
